export default __webpack_public_path__ + "static/media/HotelTravelLandingPage.78b5e7b4.jpeg";